<svelte:options accessors />

<script context="module" lang="ts">
	export let count = 0;
</script>

<script lang="ts">
	export const InstanceID = count;
	count += 1;
	import FormGroup from '../sub_components/FormGroup.svelte';
	import { onMount } from 'svelte';
	import TextInputSub from './TextInputSub.svelte';
	import type { Component, Name } from '@prisma/client';
	export let Config: Name & Component;
	export let Valid = false;
	// export let FNameErrorMsg = 'Required field';
	// export let LNameErrorMsg = 'Required field';
	// export let FNameValid = false;
	let fNameErrEl: HTMLElement;
	let fNameEl: HTMLInputElement;
	let fNameOutlineEl: HTMLElement;
	let lNameErrEl: HTMLElement;
	let lNameEl: HTMLInputElement;
	let lNameOutlineEl: HTMLElement;
	let fNameComp: TextInputSub;
	let lNameComp: TextInputSub;
	onMount(() => {});
	export function appendData(formData: FormData) {
		console.log('getting formData from name');
		fNameComp.appendData(formData);
		lNameComp.appendData(formData);
	}
	export async function validate() {
		await fNameComp.validate();
		await lNameComp.validate();
		if (fNameComp.Valid && lNameComp.Valid) {
			Valid = fNameComp.Valid && lNameComp.Valid;
		}
		return Valid;
	}
	export async function focus() {
		if (await fNameComp.validate()) {
			lNameComp.focus();
		} else {
			fNameComp.focus();
		}
	}
</script>

<FormGroup {Config}>
	{#if Config.Title}
		<div class="comp-title">{Config.Title}</div>
	{/if}
	<div class="col-sm-6">
		<TextInputSub
			InsideTitle="First Name"
			AutoComplete="given-name"
			DBCol={Config.DBCol + 'f_name'}
			Validator="Name"
			ShowCount={false}
			bind:this={fNameComp}
		/>
	</div>
	<div class="col-sm-6">
		<TextInputSub
			InsideTitle="Last Name"
			AutoComplete="family-name"
			DBCol={Config.DBCol + 'l_name'}
			Validator="Name"
			ShowCount={false}
			bind:this={lNameComp}
		/>
	</div>
</FormGroup>
